import { styled, TextField } from "@mui/material";
import { colors } from "../../theme/colors";

export const CustomTextField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    backgroundColor: "#ffffff",
    "& fieldset": {
      borderColor: "#d6e0ea",
    },
    "&:hover fieldset": {
      borderColor: colors.primary,
    },
    "&.Mui-focused fieldset": {
      borderColor: colors.primary,
      borderWidth: "1.5px",
    },
  },
  "& label.Mui-focused": {
    color: colors.primary,
    fontWeight: 600,
  },
  "& label": {
    color: "#637381",
  },
});
